import { render, staticRenderFns } from "./col.vue?vue&type=template&id=cb6e9236&scoped=true&"
import script from "./col.vue?vue&type=script&lang=js&"
export * from "./col.vue?vue&type=script&lang=js&"
import style0 from "./col.vue?vue&type=style&index=0&id=cb6e9236&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6e9236",
  null
  
)

export default component.exports